import React, {useEffect, useState} from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Checkbox,
    FormControl,
    FormLabel,
} from "@chakra-ui/react";
import {filterNonNumeric, toEnglishNumber, toPersianNumber} from "../utils/numberConversion";
import {toast} from "react-toastify";
import {api} from "../utils/gashtaltAPI";
import {DatePicker, TimePicker} from "zaman";
import { format } from "date-fns";


function ExamModal({isOpen, onClose, exam, setRefresh}) {

    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [authors, setAuthors] = useState('');
    const [editor, setEditor] = useState('');
    const [price, setPrice] = useState(0);
    const [duration, setDuration] = useState(0);
    const [startDate, setStartDate] = useState(new Date());
    const [startTime, setStartTime] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [endTime, setEndTime] = useState(new Date());
    const [show_questions, setshow_questions] = useState(true);
    // zaman's pickers are uncontrolled: they read defaultValue only on mount.
    // Bumping this key remounts them so they pick up the exam's dates.
    const [pickerKey, setPickerKey] = useState(0);
    useEffect(() => {
        if (exam) {
            setId(exam.id)
            setName(exam.name)
            setAuthors(exam.authors)
            setEditor(exam.editor)
            setPrice(exam.price)
            setDuration(exam.duration)
            setshow_questions(
                exam.show_questions === undefined ? true : !!exam.show_questions
            );
            const georgianStart = new Date(exam.startDate);
            const georgianEnd = new Date(exam.endDate);
            setStartDate(new Date(georgianStart))
            setEndDate(new Date(georgianEnd))
            setStartTime(new Date(georgianStart))
            setEndTime(new Date(georgianEnd))
        } else {
            setId('')
            setName('')
            setAuthors('')
            setEditor('')
            setPrice(0)
            setDuration(0)
            setshow_questions(true);
            setStartDate(new Date());
            setEndDate(new Date());
            setStartTime(new Date());
            setEndTime(new Date());
        }
        setPickerKey((k) => k + 1);
    }, [isOpen, exam]);
    const handlePrice = (e) => {
        setPrice(toPersianNumber(filterNonNumeric(e.target.value)));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || name === "" || !authors || authors === "" || !editor || editor === "" || !price && price !== 0 || !duration || duration === 0) {
            toast.error("فرم را کامل کنید!", {
                position: "bottom-right"
            });
            return;
        }
        try {
            const startDateTime = new Date(startDate);
            startDateTime.setHours(startTime.getHours(),startTime.getMinutes(),0,0)
            const endDateTime = new Date(endDate);
            endDateTime.setHours(endTime.getHours(),endTime.getMinutes(),0,0)
            const response = await api.post(id!=='' ? `/api/exam/${id}` : `/api/exam`, {
                name: name,
                authors: authors,
                editor: editor,
                price: toEnglishNumber(price),
                duration: toEnglishNumber(duration),
                startDate: format(startDateTime, "yyyy-MM-dd'T'HH:mm:ss"),
                endDate: format(endDateTime, "yyyy-MM-dd'T'HH:mm:ss"),
                show_questions: show_questions
            });
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            setRefresh(true);
            onClose();
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }

    }
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>افزودن آزمون جدید</ModalHeader>
                <ModalCloseButton/>
                <form onSubmit={handleSubmit}>
                    <ModalBody className="exam-modal">

                        <div className="custom-input-group">
                            <label>نام آزمون</label>
                            <input type="text" className={`form-control ${name?.length > 32 ? 'invalid' : ''}`}
                                   value={name}
                                   onChange={(e) => {
                                       setName(toPersianNumber(e.target.value))
                                   }}
                                   placeholder="نام آزمون"/>
                            <p className={`form-error ${name?.length > 32 ? 'visible' : 'hidden'}`}>نام آزمون نمی تواند
                                بیشتر از ۳۲ کاراکتر باشد.</p>
                        </div>
                        <div className="custom-input-group">
                            <label>طراحان</label>
                            <input type="text" className={`form-control`}
                                   value={authors}
                                   onChange={(e) => {
                                       setAuthors(e.target.value)
                                   }}
                                   placeholder="طراحان"/>
                        </div>
                        <div className="custom-input-group">
                            <label>ویراستار</label>
                            <input type="text" className={`form-control`}
                                   value={editor}
                                   onChange={(e) => {
                                       setEditor(e.target.value)
                                   }}
                                   placeholder="ویراستار"/>
                        </div>
                        <div
                            className="my-2 d-flex flex-row justify-content-between align-items-end custom-input-group">
                            <div className="p-2 d-flex flex-column align-items-center">
                                <label className="mb-2">مدت آزمون(دقیقه)</label>
                                <input type="text" className='form-control text-center'
                                       value={duration}
                                       onChange={(e) => {
                                           setDuration(toPersianNumber(e.target.value))
                                       }}/>
                            </div>
                            <div className="p-2 d-flex flex-column align-items-center">
                                <label>قیمت</label>
                                <input type="text" className='form-control'
                                       value={price}
                                       onChange={handlePrice}
                                       placeholder="قیمت( به تومان)" autoComplete="true"/>
                            </div>

                        </div>
                        <div className="d-flex flex-row justify-content-between align-items-end custom-input-group">
                            <div className="p-2 d-flex flex-column flex-fill align-items-center">
                                <label className="m-2">تاریخ آغاز</label>
                                <DatePicker key={`start-date-${pickerKey}`} inputClass='form-control' defaultValue={startDate} onChange={(e) => {
                                    setStartDate(e.value);
                                }}/>
                            </div>
                            <div className="p-2 d-flex flex-column flex-fill align-items-center">
                                <label className="m-2">زمان آغاز</label>
                                <TimePicker key={`start-time-${pickerKey}`} inputClass='form-control' defaultValue={startTime}
                                            onChange={(e) => {
                                                const date = new Date()
                                                date.setHours(e.hour, e.minute, 0, 0)
                                                setStartTime(date)
                                            }}/>
                            </div>
                        </div>
                        <div className="d-flex flex-row justify-content-between align-items-end custom-input-group">
                            <div className="p-2 d-flex flex-column flex-fill align-items-center">
                                <label className="m-2">تاریخ پایان</label>
                                <DatePicker key={`end-date-${pickerKey}`} inputClass='form-control' defaultValue={endDate} onChange={(e) => {
                                    setEndDate(e.value);
                                }}/>
                            </div>
                            <div className="p-2 d-flex flex-column flex-fill align-items-center">
                                <label className="m-2">زمان پایان</label>
                                <TimePicker key={`end-time-${pickerKey}`} inputClass='form-control' defaultValue={endTime}
                                            onChange={(e) => {
                                                const date = new Date()
                                                date.setHours(e.hour, e.minute, 0, 0)
                                                setEndTime(date)
                                            }}/>
                            </div>
                        </div>
                        <FormControl display="flex" alignItems="center" className="custom-input-group mt-3">
                            <Checkbox
                                isChecked={show_questions}
                                onChange={(e) => setshow_questions(e.target.checked)}
                                colorScheme="green"
                            >
                                نمایش سوالات برای کاربر
                            </Checkbox>
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='gray' mr={3} onClick={onClose} marginX={'1rem'}>
                            بستن
                        </Button>
                        <Button colorScheme='green' type='submit'>ثبت</Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
}

function DeleteExamModal({isOpen, onCloseDelete, exam, setRefresh}) {
    const [name, setName] = useState('');
    const [id, setID] = useState(0);
    useEffect(() => {
        if (isOpen) {
            if (exam) {
                setID(exam.id)
                setName(exam.name)
            } else
                onCloseDelete();
        }
    }, [isOpen]);
    const handleSubmit = async (e) => {
        try {
            const response = await api.get("/api/exam/delete/" + id);
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            setRefresh(true);
            onCloseDelete();
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }

    }
    return (
        <Modal isOpen={isOpen} onClose={onCloseDelete}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>حذف آزمون {name}</ModalHeader>
                <ModalCloseButton/>
                <ModalBody className="exam-modal">
                    <p>آیا از حذف این آزمون اطمینان دارید؟</p>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='gray' mr={3} onClick={onCloseDelete} marginX={'1rem'}>
                        بستن
                    </Button>
                    <Button colorScheme='red' onClick={handleSubmit}>حذف</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export {ExamModal, DeleteExamModal};